let marqueeSlider = document.querySelector(".s__vendor-partners .logo-list__wrapper");

if (marqueeSlider) {
  let marqueeSlide = document.querySelector(".logo-list__item");
  let mainTicker = new Flickity(".s__vendor-partners .logo-list__wrapper", {
    accessibility: true,
    resize: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    percentPosition: true,
    setGallerySize: true,
  });

  mainTicker.x = 0;
  play();

  function play() {
    mainTicker.x -= 0.8;
    mainTicker.settle(mainTicker.x);
    requestId = window.requestAnimationFrame(play);
  }

  function pause() {
    if (requestId) {
      window.cancelAnimationFrame(requestId);
      requestId = undefined;
    }
  }

  marqueeSlider.addEventListener("mouseenter", () => pause());
  marqueeSlider.addEventListener("mouseleave", () => play());
}


$(document).ready(function () {
  $(".faq__block-main.new-equipments").insertAfter(".faq__block-main.all");
  $(".faq__block-main.refurbished-equipments").insertAfter(".faq__block-main.new-equipments");
  $(".faq__block-main.tennessee-team").insertAfter(".faq__block-main.corporate-team");
});

$('.footer__content .footer-heading').on('click', function() {
  $(this).parent().toggleClass('footer-active');
});

$(document).ready(function () {
  $(".custom-contact-form__block--fileupload input").on("change", function () {
    var fileInput = $(this)[0].files[0];
    var fileName = fileInput.name;
    var fileSize = fileInput.size;
    var fileType = fileInput.type;

    if (
      fileType === "image/jpeg" ||
      fileType === "image/png" ||
      fileType === "image/gif" ||
      fileType === "image/svg+xml" ||
      fileType === "image/webp"
    ) {
      if (fileSize < 5242880) {
        $(".filename").show();
        $(".filename").text("Image uploaded - " + fileName);
      } else {
        alert("File size exceeds 5MB. Please upload a smaller file.");
        $(this).val("");
        $(".filename").hide();
        $(".filename").text("Upload Image");
      }
    } else {
      alert("Invalid file format. Please upload a JPEG, PNG, GIF, SVG, or WebP file.");
      $(this).val("");
      $(".filename").hide();
      $(".filename").text("Upload Image");
    }
  });
});

$(window).on("resize", function () {
  var windowWidth = $(window).width();

  if (windowWidth < 601) {
    // $('.s__vendor-partners.s__jetvac-team .faq__tags .faq__tags-tag').click(function() {
    //     var tag = $(this).attr('data-tag');

    //     var targetSection = $('.s__vendor-partners.s__jetvac-team .faq__block-main').filter(function() {
    //         return $(this).attr('data-heading') === tag;
    //     });

    //     if (targetSection.length) {
    //         $('html, body').animate({
    //             scrollTop: targetSection.offset().top - $('.s__vendor-partners.s__jetvac-team .faq__block-main').offset().top + $(window).scrollTop()
    //         }, 1000); 
    //     }
    // });
  }
});
$(window).trigger("resize");

$(document).ready(function() {
  $('.review-video-slider').flickity({
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: true,
    prevNextButtons: true,
    pageDots: false
  });
});

$('.mobile-menu__toggle-icon .mobile-header__open-menu').on('click', function () {
  $(this).parent().addClass('is-active');    
  $(this).css('opacity', 0);
  $('.mobile-menu__toggle-icon .mobile-header__close-menu').css('opacity', 1);
});

$('.mobile-menu__toggle-icon .mobile-header__close-menu').on('click', function () {
  $(this).parent().removeClass('is-active');    
  $(this).css('opacity', 0);
  $('.mobile-menu__toggle-icon .mobile-header__open-menu').css('opacity', 1);
});

$(document).ready(function() {
    // Define the HTML content
    var htmlContent = `
        <div class="logo-list__item five small-down--one-half column">
            <a href="mailto:bill@jet-vac.com">
                <h5 class="is-h5 name">Bill Waisanen</h5>
                <p class="is-text title">Branch Manager</p>
                <p class="is-text title email">bill@jet-vac.com</p>
                <h6 class="is-h6 location">SC</h6>
            </a>
        </div>

        <div class="logo-list__item five small-down--one-half column">
            <a href="mailto:cole@jet-vac.com">
                <h5 class="is-h5 name">Cole Williams</h5>
                <p class="is-text title">Special Projects Associate</p>
                <p class="is-text title email">cole@jet-vac.com</p>
                <h6 class="is-h6 location">SC</h6>
            </a>
        </div>

        
    `;

    // Append the HTML content inside the given selector
    $('#sumter-south-carolinaheading_qvb3ky .faq__block-main__questions').append(htmlContent);
});
